export default __webpack_public_path__ + "static/bg-whoweare-5bc5a50118e86c7b95edb8c14c04553f.svg";